var _linearGradient, _path, _linearGradient2, _path2, _linearGradient3, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsOffice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yjxgqidz2JT1PABcYtFE5a",
    x1: 31.645,
    x2: 31.645,
    y1: 6.839,
    y2: 40.615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e68e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.036,
    stopColor: "#e38400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.171,
    stopColor: "#db6200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.299,
    stopColor: "#d44a00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.417,
    stopColor: "#d03b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515,
    stopColor: "#cf3600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.878,
    stopColor: "#d22900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d42400"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Yjxgqidz2JT1PABcYtFE5a)",
    d: "M35.883,7.341C37.726,7.85,39,9.508,39,11.397v25.162c0,1.906-1.301,3.57-3.168,4.065 L24.29,43.863L28,36V11l-3.148-6.885L35.883,7.341z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yjxgqidz2JT1PABcYtFE5b",
    x1: 13.922,
    x2: 29.051,
    y1: 34.951,
    y2: 41.073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f52537"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.293,
    stopColor: "#f32536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.465,
    stopColor: "#ea2434"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.605,
    stopColor: "#dc2231"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.729,
    stopColor: "#c8202c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.841,
    stopColor: "#ae1e25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.944,
    stopColor: "#8f1a1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a1818"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Yjxgqidz2JT1PABcYtFE5b)",
    d: "M28,35v3.927c0,3.803-3.824,6.249-7.019,4.491l-6.936-4.445 c-0.802-0.466-1.236-1.462-0.964-2.457C13.334,35.59,14.202,35,15.115,35H28z"
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Yjxgqidz2JT1PABcYtFE5c",
    x1: 5.382,
    x2: 25.874,
    y1: 32.289,
    y2: 1.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d96ab1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#d9538b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#d91a2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.575,
    stopColor: "#d31a29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#c21926"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#a71821"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.929,
    stopColor: "#811619"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#691515"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Yjxgqidz2JT1PABcYtFE5c)",
    d: "M21.946,4.526l-11.924,6.786C8.772,12.024,8,13.351,8,14.789v18.429 c0,1.357,1.459,2.215,2.645,1.554l4.472-2.491C15.662,31.978,16,31.402,16,30.778V17.743c0-1.307,0.78-2.48,1.963-2.949L28,11.308 v-3.09C28,5.014,24.669,2.983,21.946,4.526z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsOffice);
export default __webpack_public_path__ + "static/media/ms_office.5b0bcc204e253e2e1f8742363cabb41c.svg";
export { ForwardRef as ReactComponent };